export default __webpack_public_path__ + "static/media/edi-header-mobile.23bcf12b.jpg";